import Barcode from "react-barcode";
import logo from "../../logo.svg";
import { signInUser } from "../Utility/Auth";
import { resolvePhotoUrl } from "../Utility/resolvePhotoUrl";
import { useEffect, useState } from "react";
import { useWarehouseQuery } from "../../services/warehouseApi";

const TpnHeader = ({ tpn, format, title }) => {
  const auth = signInUser();
  const { storeSettings } = auth;

  // console.log("tpn", tpn);
  // console.log(purchase);
  return (
    <>
      <div className="row  pb-3 mb-1 border-bottom">
        <div className="col-7">
          <img
            src={resolvePhotoUrl(
              storeSettings?.storePhoto || storeSettings?.photo,
              logo
            )}
            height="40"
            alt="not Image"
          />
        </div>

        <div className="col-5">
          <p className="p-0 m-0 text-end">
            <b>Hotline: </b> {storeSettings?.phone || "01700000000"}
          </p>
          <p className="p-0 m-0 text-end">
            <small>{tpn?.warehouseFrom?.name}</small>{" "}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-6 print-header-text">
          <p>
            <b>To</b> <br />
            Warehouse: {tpn?.warehouseTo?.name} <br />
            {/* {tpn?.warehouseTo?.email} <br /> */}
            Phone: {tpn?.warehouseTo?.phone} <br />
            Address: {tpn?.warehouseTo?.address} <br />
          </p>

          <p>
            <b>Form</b> <br />
            WareHouse: {tpn?.warehouseFrom?.name} <br />
            {/* {tpn?.warehouseTo?.email} <br /> */}
            Phone: {tpn?.warehouseFrom?.phone} <br />
            Address: {tpn?.warehouseFrom?.address} <br />
          </p>
        </div>
        <div className="col-6 text-end">
          {!tpn?.print ? <h4>[ORIGINAL]</h4> : <h4>[DUPLICATE]</h4>}

          <h4>{title}</h4>
          <span className="ps-6 d-block">
            <p>
              <b>Tpn No:</b> {tpn?.tpnNo}
              <br />
              <b>PO Date:</b>{" "}
              {tpn?.createdAt && format(new Date(tpn?.createdAt), "MM-dd-yyyy")}{" "}
              <br />
              <b>PO Time:</b>{" "}
              {tpn?.createdAt && format(new Date(tpn?.createdAt), "h:m:s aaa")}
              <br />
              <b>Status:</b> {tpn.status}
            </p>
            <p className="text-end bar-code">
              {/* <Barcode
                value={purchase?.poNo}
                height="60"
                width="2"
                fontSize="10"
              /> */}
            </p>
          </span>
        </div>
      </div>
    </>
  );
};

export default TpnHeader;
